import { concat } from 'rxjs'
import { switchMap } from 'rxjs/operators'

import {
  createClearLoading$,
  createLoading$,
} from '@apiEnabler/api-enabler-common/lib/loading'
import { updateMortgagesGeneratedState$ } from '@apiEnabler/ob-common/lib/mortgage-consents'

import { createStoreNavigateTo$ } from './navigation'
import { displayMortgages$ } from './intents'
import { initialData$ } from './customer'

export const mortgagesDisplay$ = displayMortgages$.pipe(
  switchMap(() =>
    concat(
      initialData$,
      createLoading$('Loading mortgage consents'),
      createStoreNavigateTo$('/mortgages'),
      updateMortgagesGeneratedState$,
      createClearLoading$('Loading mortgage consents')
    )
  )
)

export const PERMISSION_LABELS = {
  ReadCustomerMortgageAccountAndProducts: 'Read mortgage account and products',
}
